<!-- 

CONFIGURACAO PARA CORREIOS

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        obj: { type: Object },
    },

    components: {
    },

    data () {
        return {
            editing: false,
            correiosObj: null,
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {

        handleDesativar () {
            this.obj.habilitaCorreios = false
            this.$emit('saveconfig')
        },

        handleAtivar () {
            this.editing = true
            this.correiosObj = {...this.obj.correios}
            this.$nextTick(function () {
                this.$refs.nome.focus()
            })
        },

        handleSalvar () {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.obj.habilitaCorreios = true
                    this.editing = false
                    this.$emit('saveconfig')
                }
            })
        },

        handleEdit () {
            this.correiosObj = {...this.obj.correios}
            this.editing = true            
            this.$nextTick(function () {
                this.$refs.nome.focus()
            })
        },

        handleCancelar () {
            this.obj.correios = this.correiosObj
            this.editing = false
            this.$emit('saveconfig')
        },

    },

    watch: {

    },

    mounted () {

    },

    created () {

    }

}

</script>

<template>
  <div class="mt-2">
    <span class="lbl-deal-title mb-3">Correios</span>
    <div class="row mb-2">
        <div class="col">
            <span>Configure as formas de envio que serão exibidas para o comprador no fechamento da venda!</span>
        </div>
    </div>


    <div class="row" v-if="!editing">
        <div class="col-md-4">
            <img src="correios.png" height="40">
        </div>
        <div class="col-md-4">
        </div>
        <div class="col-md-4">
            <span class="badge badge-green">Esta forma está Ativada</span>
            <v-button icon="fa-pencil" label="" @click="handleEdit"></v-button>
            <v-button icon="fa-pencil" title="Desativar Correios" label="" @click="handleEdit"></v-button>
        </div>
    </div>


    <div class="border p-3 mb-4" v-if="editing">
        <div class="row" v-if="!obj.correios.contrato">
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.correios.habilitasedex" :value-checked="true" :value-unchecked="false" label="Habilita SEDEX"></input-checkbox>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.correios.habilitapac" :value-checked="true" :value-unchecked="false" label="Habilita PAC"></input-checkbox>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <input-checkbox v-model="obj.correios.contrato" :value-checked="true" :value-unchecked="false" label="Informar dados do meu contrato com os Correios"></input-checkbox>
            </div>
        </div>
        <div class="row mt-3" v-if="obj.correios.contrato">
            <div class="col-md-3 col-12">
                <v-label label="Código ECT"></v-label>
                <form-field v-model="obj.correios.codempresa" type="text" case="normal" :disabled="!editing"
                :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-3 col-12">
                <v-label label="Senha de acesso"></v-label>
                <form-field v-model="obj.correios.senha" type="text" case="normal" :disabled="!editing"
                :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.correios.habilitasedex" :value-checked="true" :value-unchecked="false" label="Habilita SEDEX"></input-checkbox>
            </div>
            <div class="w-100"></div>
            <div class="col-md-3 col-12 ml-5" v-if="obj.correios.habilitasedex">
                <v-label label="Informe o código SEDEX contratado"></v-label>
                <form-field v-model="obj.correios.codigosedex" type="text" case="normal" :disabled="!editing"
                :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-3 col-12">
                <input-checkbox v-model="obj.correios.habilitapac" :value-checked="true" :value-unchecked="false" label="Habilita PAC"></input-checkbox>
            </div>
            <div class="w-100"></div>
            <div class="col-md-3 col-12 ml-5" v-if="obj.correios.habilitapac">
                <v-label label="Informe o código PAC contratado"></v-label>
                <form-field v-model="obj.correios.codigopac" type="text" case="normal" :disabled="!editing"
                :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.correios.maopropria" :value-checked="true" :value-unchecked="false" label="Serviço Mão Própria"></input-checkbox>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.correios.valordeclarado" :value-checked="true" :value-unchecked="false" label="Serviço Valor Declarado"></input-checkbox>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.correios.avisorecebimento" :value-checked="true" :value-unchecked="false" label="Serviço Aviso de Recebimento"></input-checkbox>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3" v-if="editing">
                <v-button label="Salvar" :success="true" @click="handleSalvar"></v-button>
                <v-button label="Cancelar" @click="handleCancelar"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="obj.habilitaCorreios && !editing">
                <v-button label="Excluir" :danger="true" @click="handleDesativar"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEdit"></v-button>
            </div>
        </div>
    </div>
  </div>

</template>

<style>


</style>



// WEBPACK FOOTER //
// src/forms-loja/config-correios-form-loja.vue